import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Zoom } from 'swiper/core'
import clsx from 'clsx'
import styles from './Dettagli.module.sass'
import AssignId from '../AssignId'
import VisibilitySensor from '../VisibilitySensor'
import ArrowRight from '../icons/ArrowRight'
import ArrowLeft from '../icons/ArrowLeft'
import Button from '../Button'
import { useState } from 'react'
import { DettagliPageConfig, PhotoModalConfig } from '../configuration'

SwiperCore.use([Pagination, Zoom]);

export default function Dettagli() {

    const [swiper, setSwiper] = useState(undefined)
    const [isImageZoomed, setImageZoomed] = useState({})
    const { items } = DettagliPageConfig;

    const getIcon = (iconName) => {
        switch (iconName) {
            case 'ArrowRight': return <ArrowRight />;
            case 'ArrowLeft': return <ArrowLeft />;
            default: return null;
        }
    }

    return (
        <div className={styles.root}>
            <AssignId
                absolute
                y='-60px'
                yMobile='0'
                id={DettagliPageConfig.id}
            />
            <VisibilitySensor index={5} />
            <div className={`${styles.slider} scroll-fadein-late`}>
                <Swiper
                    slidesPerView={1}
                    initialSlide={0}
                    spaceBetween={32}
                    pagination={{ clickable: true }}
                    className={styles.swiper}
                    onSwiper={(s) => setSwiper(s)}
                    onZoomChange={(swiper, scale) => {
                        const currentKey = items[swiper.activeIndex].key;
                        setImageZoomed(prevState => ({
                            ...prevState,
                            [currentKey]: scale > 1
                        }));
                    }}
                    zoom={true}
                    breakpoints={{
                        768: {
                            spaceBetween: 10,
                        }
                    }}
                >
                    {items.map(x => (
                        <SwiperSlide key={x.key}>
                            <div className={`${styles.card}`}>
                                <h2 className={`${styles.title} ${styles['title--mobile']}`}>{x.title}</h2>
                                <div className={styles.imageBox}>
                                    <div className="swiper-zoom-container">
                                        <img src={x.image} alt={x.alt} className={styles.itemImage} />
                                    </div>
                                    {x.key === 2 && (
                                        <>
                                            <p className={clsx(styles.accesibility, isImageZoomed[x.key] && 'helper-text-fadeOut')}>{PhotoModalConfig.zoomInText}</p>
                                            <p className={clsx(styles.accesibility, !isImageZoomed[x.key] && 'helper-text-fadeOut')}>{PhotoModalConfig.dragToExploreText}</p>
                                        </>
                                    )}
                                </div>
                                <div className={`${styles.content}`}>
                                    <h2 className={`${styles.title} ${styles['title--desktop']}`}>{x.title}</h2>
                                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: x.description }} />
                                    <Button label={x.ctaLabel} icon={getIcon(x.icon)} iconPos={x.iconPos} variant='ghost' onClick={() => swiper?.slideTo(x.slideTo)} />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}